export default __webpack_public_path__ + "static/media/loadingAnimation.6d52626e.gif";